import {connect} from 'react-redux';
import IngestConfigContainer from '../IngestConfig/IngestConfigContainer';
import {
    setInitialValuesForEditingItemAction,
    resetInitialValuesForEditingItemAction,
    editIngestConfigItemAction,
} from './Redux/EditingIngestConfigActions';

export const mapState = (state: any) => {
    return {
        initialValues: state.ingest.initialValuesForEditingIngestConfig,
    };
};

const mapDispatch = {
    setInitialValuesForEditingItem: setInitialValuesForEditingItemAction,
    resetInitialValuesForEditingItem: resetInitialValuesForEditingItemAction,
    saveIngestConfigItem: editIngestConfigItemAction,
};

export default connect(mapState, mapDispatch)(IngestConfigContainer as any);
